/**
 * Libs
 */
import React from 'react';

/**
 * Components
 */
import { Typography } from 'src/ui/common/atoms/typography';

/**
 * Styles
 */
import { StyledFaqCategoriesMenu, StyledFaqCategoryLink } from './faq-categories-menu.styles';

interface IProperties {
    active: string;
    categories: Array<{
        title: string;
        anchor: string;
    }>;
}

export const FaqCategoriesMenu: React.VFC<IProperties> = React.memo(({ categories, active }) => (
    <StyledFaqCategoriesMenu>
        <ul>
            {categories.map(({ title, anchor }) => (
                <li key={anchor}>
                    <StyledFaqCategoryLink
                        key={anchor}
                        href={`#${anchor}`}
                        data-itemName={anchor}
                        active={anchor === active}
                    >
                        <Typography color="black">{title}</Typography>
                    </StyledFaqCategoryLink>
                </li>
            ))}
        </ul>
    </StyledFaqCategoriesMenu>
));

FaqCategoriesMenu.displayName = 'FaqCategoriesMenu';
